import { Text } from '@factorialco/deprecated-design-system'
import { MyCardFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import MoneyWithCurrency from 'modules/core/lib/money'

export const RemainingThisMonth = ({ card }: { card: MyCardFragment }) => {
  const {
    access: { locale },
  } = useCurrentSession()
  if (!card.cardLimit.remainingForCurrentPeriod || card.creationSource === 'salary') {
    return null
  }

  return (
    <Text.Normal weight="medium" size="200">
      {MoneyWithCurrency({
        optionalDecimals: true,
        amount: card.cardLimit.remainingForCurrentPeriod,
        currency: card.cardLimit.currency,
        locale,
      })}
    </Text.Normal>
  )
}
